import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import currentUserState from "utils/currentUserState";
import APILink from "components/ui/APILink";
import AccessibleLinkContent from "components/ui/AccessibleLinkContent";
import HairlineRule from "components/ui/HairlineRule";

export function FinaidSummaryFooter({ aidYear }) {
  const {
    canSeeCSLinks,
    financialAidSummary: { loadState, financialAidSummary } = {},
  } = useSelector((state) => {
    const { myStatus: { canSeeCSLinks } = {} } = state;
    const { financialAidSummary } = currentUserState(state);
    return { financialAidSummary, canSeeCSLinks };
  });

  const { aid, links: { financialAidWebsite } = {} } =
    financialAidSummary || {};
  const { [aidYear.id]: currentAidYearData } = aid;
  const { shoppingSheetLink } = currentAidYearData;

  if (loadState === "success") {
    return (
      <>
        <HairlineRule />

        {shoppingSheetLink && canSeeCSLinks && (
          <div>
            <APILink link={shoppingSheetLink}>
              {({ props, text, showNewWindow }) => (
                <a {...props}>
                  <AccessibleLinkContent showNewWindow={showNewWindow}>
                    <i className="fa fa-file-text"></i> {text}
                  </AccessibleLinkContent>
                </a>
              )}
            </APILink>
          </div>
        )}

        <div>
          <APILink link={financialAidWebsite} />
        </div>
      </>
    );
  }

  if (loadState === "failure") {
    return <>There was a failure</>;
  }

  return null;
}

FinaidSummaryFooter.propTypes = {
  aidYear: PropTypes.object,
};
